import { nanoid } from 'nanoid';

export function generateId(): string {
  return nanoid(12);
}

export { generateId as genId };
